import { PuffLoader } from 'react-spinners';
/////////////////////////////////////////////

interface TokenListItemProps {
	image: string;
	tokenBalance: string;
	symbol: string;
}

export const TokenListItem = ({
	tokenBalance,
	symbol,
	image,
}: TokenListItemProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex rounded-2xl items-center bg-customer-900/50 px-4 py-5 option-menu-setting w-full">
			<img src={image} height={24} width={24} />
			<span className="w-full ml-2">{symbol}:</span>
			<div className="flex flex-grow items-end gap-2 w-full justify-end min-h-[24px]">
				<PuffLoader
					color="red"
					size={24}
					loading={tokenBalance === ''}
				/>
				{tokenBalance && (
					<span className="font-bold">
						{parseFloat(tokenBalance).toFixed(2)}
					</span>
				)}
			</div>
		</div>
	);
};
